import { useShallowEffect } from '@mantine/hooks';
import { useEffect } from 'react';
import { useAppContainerContext } from './AppContainerContext';
import { ContentMeta } from './types';

export function useAppContainer() {
  const { siestaMode, setSiestaMode, siestaBusyGlowTop, setSiestaBusyGlowTop } =
    useAppContainerContext();

  return {
    siestaMode,
    setSiestaMode,
    siestaBusyGlowTop,
    setSiestaBusyGlowTop,
  };
}

export function useContentMeta(data: ContentMeta) {
  const { setContentMeta } = useAppContainerContext();

  useShallowEffect(() => {
    setContentMeta(data);
  }, [data, setContentMeta]);

  useEffect(() => {
    return () => setContentMeta(null);
  }, [setContentMeta]);
}
